/* eslint-disable */ /* This file was auto-generated by @graphql-codegen (`yarn run generate`) */

import { GraphQLResolveInfo } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type AdditionalEntityFields = {
  path?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type Alert = {
  __typename?: 'Alert';
  assets?: Maybe<Array<Scalars['String']>>;
  ccarClient: Scalars['String'];
  chain?: Maybe<Chain>;
  createdDate: Scalars['Float'];
  description: Scalars['String'];
  events: Array<AlertEvent>;
  id: Scalars['ID'];
  link?: Maybe<AlertLink>;
  marketId?: Maybe<Scalars['String']>;
  open: Scalars['Boolean'];
  severity: AlertSeverity;
  title: Scalars['String'];
  type?: Maybe<AlertType>;
  updatedDate: Scalars['Float'];
};

export type AlertEvent = {
  __typename?: 'AlertEvent';
  date: Scalars['Float'];
  value: Scalars['Float'];
};

export type AlertLink = {
  __typename?: 'AlertLink';
  href: Scalars['String'];
  title: Scalars['String'];
};

export enum AlertSeverity {
  High = 'HIGH',
  Info = 'INFO'
}

export enum AlertType {
  BadDebt = 'BAD_DEBT',
  Borrow = 'BORROW',
  BorrowCaps = 'BORROW_CAPS',
  DebtCeiling = 'DEBT_CEILING',
  HealthCheck = 'HEALTH_CHECK',
  Liquidations = 'LIQUIDATIONS',
  Liquidity = 'LIQUIDITY',
  PriceChange = 'PRICE_CHANGE',
  StablePeg = 'STABLE_PEG',
  Supply = 'SUPPLY',
  SupplyCaps = 'SUPPLY_CAPS',
  Utilizations = 'UTILIZATIONS',
  ValueAtRisk = 'VALUE_AT_RISK',
  Whale = 'WHALE'
}

export enum Chain {
  Arbitrum = 'Arbitrum',
  ArbitrumGoerli = 'Arbitrum_Goerli',
  Avalanche = 'Avalanche',
  Base = 'Base',
  Binance = 'Binance',
  Ethereum = 'Ethereum',
  Evmos = 'Evmos',
  Fantom = 'Fantom',
  Gnosis = 'Gnosis',
  Goerli = 'Goerli',
  Harmony = 'Harmony',
  Metis = 'Metis',
  Optimism = 'Optimism',
  Polygon = 'Polygon'
}

export type Query = {
  __typename?: 'Query';
  riskAlerts: Array<Alert>;
};

export type AlertFragment = { __typename?: 'Alert', ccarClient: string, id: string, type?: AlertType | null, assets?: Array<string> | null, marketId?: string | null, chain?: Chain | null, title: string, description: string, createdDate: number, updatedDate: number, severity: AlertSeverity, open: boolean, link?: { __typename?: 'AlertLink', title: string, href: string } | null };

export type RiskAlertsQueryVariables = Exact<{ [key: string]: never; }>;


export type RiskAlertsQuery = { __typename?: 'Query', riskAlerts: Array<{ __typename?: 'Alert', ccarClient: string, id: string, type?: AlertType | null, assets?: Array<string> | null, marketId?: string | null, chain?: Chain | null, title: string, description: string, createdDate: number, updatedDate: number, severity: AlertSeverity, open: boolean, link?: { __typename?: 'AlertLink', title: string, href: string } | null }> };



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  AdditionalEntityFields: AdditionalEntityFields;
  Alert: ResolverTypeWrapper<Alert>;
  AlertEvent: ResolverTypeWrapper<AlertEvent>;
  AlertLink: ResolverTypeWrapper<AlertLink>;
  AlertSeverity: AlertSeverity;
  AlertType: AlertType;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']>;
  Chain: Chain;
  Float: ResolverTypeWrapper<Scalars['Float']>;
  ID: ResolverTypeWrapper<Scalars['ID']>;
  Query: ResolverTypeWrapper<{}>;
  String: ResolverTypeWrapper<Scalars['String']>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  AdditionalEntityFields: AdditionalEntityFields;
  Alert: Alert;
  AlertEvent: AlertEvent;
  AlertLink: AlertLink;
  Boolean: Scalars['Boolean'];
  Float: Scalars['Float'];
  ID: Scalars['ID'];
  Query: {};
  String: Scalars['String'];
};

export type AbstractEntityDirectiveArgs = {
  additionalFields?: Maybe<Array<Maybe<AdditionalEntityFields>>>;
  discriminatorField: Scalars['String'];
};

export type AbstractEntityDirectiveResolver<Result, Parent, ContextType = any, Args = AbstractEntityDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type ColumnDirectiveArgs = {
  overrideType?: Maybe<Scalars['String']>;
};

export type ColumnDirectiveResolver<Result, Parent, ContextType = any, Args = ColumnDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type EmbeddedDirectiveArgs = { };

export type EmbeddedDirectiveResolver<Result, Parent, ContextType = any, Args = EmbeddedDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type EntityDirectiveArgs = {
  additionalFields?: Maybe<Array<Maybe<AdditionalEntityFields>>>;
  embedded?: Maybe<Scalars['Boolean']>;
};

export type EntityDirectiveResolver<Result, Parent, ContextType = any, Args = EntityDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type IdDirectiveArgs = { };

export type IdDirectiveResolver<Result, Parent, ContextType = any, Args = IdDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type LinkDirectiveArgs = {
  overrideType?: Maybe<Scalars['String']>;
};

export type LinkDirectiveResolver<Result, Parent, ContextType = any, Args = LinkDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type MapDirectiveArgs = {
  path: Scalars['String'];
};

export type MapDirectiveResolver<Result, Parent, ContextType = any, Args = MapDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type UnionDirectiveArgs = {
  additionalFields?: Maybe<Array<Maybe<AdditionalEntityFields>>>;
  discriminatorField?: Maybe<Scalars['String']>;
};

export type UnionDirectiveResolver<Result, Parent, ContextType = any, Args = UnionDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type AlertResolvers<ContextType = any, ParentType extends ResolversParentTypes['Alert'] = ResolversParentTypes['Alert']> = {
  assets?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  ccarClient?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  chain?: Resolver<Maybe<ResolversTypes['Chain']>, ParentType, ContextType>;
  createdDate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  events?: Resolver<Array<ResolversTypes['AlertEvent']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  link?: Resolver<Maybe<ResolversTypes['AlertLink']>, ParentType, ContextType>;
  marketId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  open?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  severity?: Resolver<ResolversTypes['AlertSeverity'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['AlertType']>, ParentType, ContextType>;
  updatedDate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['AlertEvent'] = ResolversParentTypes['AlertEvent']> = {
  date?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlertLinkResolvers<ContextType = any, ParentType extends ResolversParentTypes['AlertLink'] = ResolversParentTypes['AlertLink']> = {
  href?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  riskAlerts?: Resolver<Array<ResolversTypes['Alert']>, ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  Alert?: AlertResolvers<ContextType>;
  AlertEvent?: AlertEventResolvers<ContextType>;
  AlertLink?: AlertLinkResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
};

export type DirectiveResolvers<ContextType = any> = {
  abstractEntity?: AbstractEntityDirectiveResolver<any, any, ContextType>;
  column?: ColumnDirectiveResolver<any, any, ContextType>;
  embedded?: EmbeddedDirectiveResolver<any, any, ContextType>;
  entity?: EntityDirectiveResolver<any, any, ContextType>;
  id?: IdDirectiveResolver<any, any, ContextType>;
  link?: LinkDirectiveResolver<any, any, ContextType>;
  map?: MapDirectiveResolver<any, any, ContextType>;
  union?: UnionDirectiveResolver<any, any, ContextType>;
};

export const AlertFragmentDoc = gql`
    fragment Alert on Alert {
  ccarClient
  id
  type
  assets
  marketId
  chain
  title
  description
  createdDate
  updatedDate
  severity
  open
  link {
    title
    href
  }
}
    `;
export const RiskAlertsDocument = gql`
    query RiskAlerts {
  riskAlerts {
    ...Alert
  }
}
    ${AlertFragmentDoc}`;

/**
 * __useRiskAlertsQuery__
 *
 * To run a query within a React component, call `useRiskAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRiskAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRiskAlertsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRiskAlertsQuery(baseOptions?: Apollo.QueryHookOptions<RiskAlertsQuery, RiskAlertsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RiskAlertsQuery, RiskAlertsQueryVariables>(RiskAlertsDocument, options);
      }
export function useRiskAlertsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RiskAlertsQuery, RiskAlertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RiskAlertsQuery, RiskAlertsQueryVariables>(RiskAlertsDocument, options);
        }
export type RiskAlertsQueryHookResult = ReturnType<typeof useRiskAlertsQuery>;
export type RiskAlertsLazyQueryHookResult = ReturnType<typeof useRiskAlertsLazyQuery>;
export type RiskAlertsQueryResult = Apollo.QueryResult<RiskAlertsQuery, RiskAlertsQueryVariables>;